import { render, staticRenderFns } from "./AddFileToTicket.vue?vue&type=template&id=10ba6e74&"
import script from "./AddFileToTicket.vue?vue&type=script&lang=ts&"
export * from "./AddFileToTicket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports